import { render, staticRenderFns } from "./SchemeReview.vue?vue&type=template&id=1fb2ffda&scoped=true&"
import script from "./SchemeReview.vue?vue&type=script&lang=js&"
export * from "./SchemeReview.vue?vue&type=script&lang=js&"
import style0 from "./SchemeReview.vue?vue&type=style&index=0&id=1fb2ffda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2ffda",
  null
  
)

export default component.exports